import React, { Component } from "react";

import { CLink } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

const FileDownload = require("js-file-download");

class ActivityTVShare extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activity_id: this.props.match.params.id,
      activity: undefined,
      // name: "teste",
      loading: true
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    axios
      .get(
        `${URL.api}activity/activity/singleView/${this.state.activity_id}?qr=true`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        this.setState({
          activity: resp.data.data,
          loading: false
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Col md="12">
              <h3 className="mb-4">
                Obtenha os QRCodes da atividade{" "}
                <strong>{this.state.activity.name}</strong>
              </h3>
            </Col>
            {this.state.activity.items.map(item => (
              <Col md="3">
                <div className="card d-flex flex-column align-items-center justify-content-center p-4 text-center">
                  <img src={item.image} className="w-100" />
                  {item.name}
                  <div className="small mt-2">
                    {item.image ? (
                      <>
                        <CLink href={item.image} download="qrcode.png">
                          <i className="fa fa-cloud-download mr-1"></i>Baixar
                          imagem
                        </CLink>
                        {" | "}
                        <CLink
                          href="#"
                          onClick={() =>
                            this.copyText(
                              `${window.location.origin}/tv/${item.activity_id}/${item.id}`
                            )
                          }
                        >
                          <i className="fa fa-share-alt mr-1"></i>Copiar link
                        </CLink>
                      </>
                    ) : (
                      <span className="text-danger">
                        Item não disponível por QR Code
                      </span>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTVShare);
